import { useBoundaries } from "../../../context/boundary";
import ToggleButton from "../../ToggleButton/ToggleButton";

const MeasurementToggle = () => {
  const { measurementMode, setMeasurementMode } = useBoundaries();

  return (
    <div className="d-flex row justify-content-between align-items-center px-2 py-2 ">
      <div className="w-100 justify-content-center align-items-center d-flex">
        <div className="w-50">
          <ToggleButton
            options={[
              { value: "mi", label: "Miles" },
              { value: "km", label: "Km" },
            ]}
            value={measurementMode}
            onChange={(value) => setMeasurementMode(value as any)}
          />
        </div>
      </div>

      <div className="w-50"></div>
    </div>
  );
};

export default MeasurementToggle;
